export default __webpack_public_path__ + "static/media/Alexandre.4aed086b.png";